<template lang='html'>
  <section class='day'>

    <v-expansion-panel-header class="pt-0 pb-0" icon="mdi-lock" :color="getBackgroundColor(getDayType(this.dayData))" hide-actions>
      <section class='daySummary'>
        <v-row no-gutters class="body-2 d-flex flex-row">
          <v-col cols="auto">
            <v-row>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="pa-1"
                  >
                    {{ getDayTypeIcon(dayData) }}
                  </v-icon>
                </template>
                <span>{{ getAbsenceTitle(dayData) }}</span>
              </v-tooltip>
              <v-card class="pa-2 font-weight-bold d-flex flex-column" min-width="115px" flat color="transparent">
                <label id="weekDayName" class="overline darkgrey-tableheader" >{{ getWeekdayName(dayData) }}</label>
                <label id='date'>{{formatDate(dayData.date, true)}}</label>
              </v-card>
            </v-row>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="auto" align-self="center">
            <v-tooltip left :open-on-focus="false">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="ghost-icon"
                  icon
                  small
                  @click.stop="jumpToDate"
                  v-on="on"
                >
                  <v-icon color="grey darken-1">mdi-arrow-up</v-icon>
                </v-btn>
              </template>
              <span>Zum Tag springen</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </section>
    </v-expansion-panel-header>

  </section>
</template>

<script lang='js'>
  import StatusColorCalculator from '@/mixins/StatusColorCalculator.vue';

  export default {
    name: 'daySummary',
    props: ['dayData'],
    mixins: [StatusColorCalculator],
    methods: {
      jumpToDate() {
        this.$root.$emit('jumpToDate', this.dayData.date);
      }
    },
    created() {},
    data() {
      return {}
    }
  }
</script>
<style lang="scss">
.v-expansion-panel-header {
  cursor: default
}
</style>